import axiosClient from './axiosClient';
import { API_URLS } from '../constants/apiUrls';
import { IEquipmentComplianceUpdate } from '../type/updaterCompliance';
import { IUpdateComplianceStaff } from '../type/updateStaffCompliance';
import { IUpdateStaffInStaffCompliance } from '../type/updateStaff';
import { IUpdateStaffInEquipmentCompliance } from '../type/updateStaffInEquipment';

const complianceApi = {
  getComplianceDetails: (ownerId: number, date: string, id?: number) => {
    return axiosClient.get(
      `${API_URLS.COMPLIANCE_URL}/details?ownerId=${ownerId}&date=${date}&contactStaffId=${id}`,
    );
  },

  getStaffList: (ownerId: number) => {
    return axiosClient.get(`${API_URLS.STAFF_COMPLIANCE}?ownerId=${ownerId}`);
  },

  updateComplianceDetails: (data: IEquipmentComplianceUpdate) => {
    return axiosClient.put(`${API_URLS.UPDATE_EQUIPMENT_COMPLIANCE}`, data);
  },

  updateStaffComplianceDetails: (data: IUpdateComplianceStaff) => {
    return axiosClient.put(`${API_URLS.UPDATE_STAFF_COMPLIANCE}`, data);
  },

  updateStaffInStaffCompliance: (data: IUpdateStaffInStaffCompliance[]) => {
    return axiosClient.put(`${API_URLS.UPDATE_STAFF}`, data);
  },

  updateStaffInEquipmentCompliance: (
    data: IUpdateStaffInEquipmentCompliance[],
  ) => {
    return axiosClient.put(`${API_URLS.UPDATE_STAFF_IN_COMPLIANCE}`, data);
  },
};

export default complianceApi;
